import { r as registerInstance, h, g as getElement } from './index-6e9159ae.js';
import { O as Fme, S as Iq, _ as Ih } from './headless.esm-398913ee.js';
import { S as SearchIcon } from './search-64cc84a9.js';
import { e as encodeForDomAttribute } from './string-utils-d9206c15.js';
import { d as dispatchSearchBoxSuggestionsEvent } from './suggestions-common-201b5a78.js';
import { C as Clock } from './clock-add3e9a5.js';
import { S as SafeStorage, a as StorageItems } from './local-storage-utils-17084198.js';
import { o as once } from './utils-71996adb.js';
import './event-utils-92b13243.js';
import './_commonjsHelpers-5ec8f9b7.js';

const AtomicSearchBoxQuerySuggestions = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.error = undefined;
    this.icon = undefined;
    this.maxWithQuery = undefined;
    this.maxWithoutQuery = undefined;
  }
  componentWillLoad() {
    try {
      dispatchSearchBoxSuggestionsEvent((bindings) => {
        this.bindings = bindings;
        return this.initialize();
      }, this.host);
    }
    catch (error) {
      this.error = error;
    }
  }
  renderIcon() {
    return this.icon || SearchIcon;
  }
  initialize() {
    const engine = this.bindings.engine;
    const { registerQuerySuggest, fetchQuerySuggestions } = Fme(engine);
    engine.dispatch(registerQuerySuggest({
      id: this.bindings.id,
      count: this.bindings.numberOfQueries,
    }));
    return {
      position: Array.from(this.host.parentNode.children).indexOf(this.host),
      onInput: () => engine.dispatch(fetchQuerySuggestions({
        id: this.bindings.id,
      })),
      renderItems: () => this.renderItems(),
    };
  }
  renderItems() {
    const hasQuery = this.bindings.searchBoxController.state.value !== '';
    const max = hasQuery ? this.maxWithQuery : this.maxWithoutQuery;
    return this.bindings.searchBoxController.state.suggestions
      .slice(0, max)
      .map((suggestion) => this.renderItem(suggestion));
  }
  renderItem(suggestion) {
    const hasQuery = this.bindings.searchBoxController.state.value !== '';
    return {
      part: 'query-suggestion-item',
      content: (h("div", { part: "query-suggestion-content", class: "flex items-center" }, this.bindings.getSuggestions().length > 1 && (h("atomic-icon", { part: "query-suggestion-icon", icon: this.renderIcon(), class: "w-4 h-4 mr-2 shrink-0" })), hasQuery ? (h("span", { part: "query-suggestion-text", class: "break-all line-clamp-2", innerHTML: suggestion.highlightedValue })) : (h("span", { part: "query-suggestion-text", class: "break-all line-clamp-2" }, suggestion.rawValue)))),
      key: `qs-${encodeForDomAttribute(suggestion.rawValue)}`,
      query: suggestion.rawValue,
      ariaLabel: this.bindings.i18n.t('query-suggestion-label', {
        query: suggestion.rawValue,
        interpolation: { escapeValue: false },
      }),
      onSelect: () => {
        this.bindings.searchBoxController.selectSuggestion(suggestion.rawValue);
      },
    };
  }
  render() {
    if (this.error) {
      return (h("atomic-component-error", { element: this.host, error: this.error }));
    }
  }
  get host() { return getElement(this); }
};

const AtomicSearchBoxRecentQueries = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    /**
     * The maximum number of suggestions that will be displayed if the user has typed something into the input field.
     */
    this.maxWithQuery = 3;
    this.warnUser = once(() => this.bindings.engine.logger.warn('Because analytics are disabled, the recent queries feature is deactivated.'));
    this.error = undefined;
    this.icon = undefined;
    this.maxWithQuery = 3;
    this.maxWithoutQuery = undefined;
  }
  componentWillLoad() {
    try {
      dispatchSearchBoxSuggestionsEvent((bindings) => {
        this.bindings = bindings;
        return this.initialize();
      }, this.host);
    }
    catch (error) {
      this.error = error;
    }
  }
  renderIcon() {
    return this.icon || Clock;
  }
  initialize() {
    this.storage = new SafeStorage();
    this.recentQueriesList = Iq(this.bindings.engine, {
      initialState: { queries: this.retrieveLocalStorage() },
      options: { maxLength: 1000, clearFilters: this.bindings.clearFilters },
    });
    this.recentQueriesList.subscribe(() => this.updateLocalStorage());
    return {
      position: Array.from(this.host.parentNode.children).indexOf(this.host),
      renderItems: () => this.renderItems(),
    };
  }
  retrieveLocalStorage() {
    return this.storage.getParsedJSON(StorageItems.RECENT_QUERIES, []);
  }
  updateLocalStorage() {
    if (!this.recentQueriesList.state.analyticsEnabled) {
      return this.disableFeature();
    }
    return this.storage.setJSON(StorageItems.RECENT_QUERIES, this.recentQueriesList.state.queries);
  }
  disableFeature() {
    this.warnUser();
    this.storage.removeItem(StorageItems.RECENT_QUERIES);
  }
  renderItems() {
    if (!this.recentQueriesList.state.analyticsEnabled) {
      return [];
    }
    const query = this.bindings.searchBoxController.state.value;
    const hasQuery = query !== '';
    const max = hasQuery ? this.maxWithQuery : this.maxWithoutQuery;
    const filteredQueries = this.recentQueriesList.state.queries
      .filter((recentQuery) => recentQuery !== query &&
      recentQuery.toLowerCase().startsWith(query.toLowerCase()))
      .slice(0, max);
    const suggestionElements = filteredQueries.map((value) => this.renderItem(value));
    if (suggestionElements.length) {
      suggestionElements.unshift(this.renderClear());
    }
    return suggestionElements;
  }
  renderClear() {
    return {
      key: 'recent-query-clear',
      content: (h("div", { part: "recent-query-title-content", class: "flex justify-between w-full" }, h("span", { class: "font-bold", part: "recent-query-title" }, this.bindings.i18n.t('recent-searches')), h("span", { part: "recent-query-clear" }, this.bindings.i18n.t('clear')))),
      ariaLabel: this.bindings.i18n.t('clear-recent-searches', {
        interpolation: { escapeValue: false },
      }),
      onSelect: () => {
        this.recentQueriesList.clear();
        this.bindings.triggerSuggestions();
      },
      part: 'recent-query-title-item suggestion-divider',
      hideIfLast: true,
    };
  }
  renderItem(value) {
    const query = this.bindings.searchBoxController.state.value;
    return {
      key: `recent-${encodeForDomAttribute(value)}`,
      query: value,
      part: 'recent-query-item',
      content: (h("div", { part: "recent-query-content", class: "flex items-center break-all text-left" }, h("atomic-icon", { part: "recent-query-icon", icon: this.renderIcon(), class: "w-4 h-4 mr-2 shrink-0" }), query === '' ? (h("span", { part: "recent-query-text", class: "break-all line-clamp-2" }, value)) : (h("span", { part: "recent-query-text", class: "break-all line-clamp-2", innerHTML: Ih.highlightString({
          content: value,
          openingDelimiter: '<span part="recent-query-text-highlight" class="font-bold">',
          closingDelimiter: '</span>',
          highlights: [
            {
              offset: query.length,
              length: value.length - query.length,
            },
          ],
        }) })))),
      ariaLabel: this.bindings.i18n.t('recent-query-suggestion-label', {
        query: value,
        interpolation: { escapeValue: false },
      }),
      onSelect: () => {
        if (this.bindings.isStandalone) {
          this.bindings.searchBoxController.updateText(value);
          this.bindings.searchBoxController.submit();
          return;
        }
        this.recentQueriesList.executeRecentQuery(this.recentQueriesList.state.queries.indexOf(value));
      },
    };
  }
  render() {
    if (this.error) {
      return (h("atomic-component-error", { element: this.host, error: this.error }));
    }
  }
  get host() { return getElement(this); }
};

export { AtomicSearchBoxQuerySuggestions as atomic_search_box_query_suggestions, AtomicSearchBoxRecentQueries as atomic_search_box_recent_queries };

//# sourceMappingURL=atomic-search-box-query-suggestions_2.entry.js.map